/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-22 16:58:46
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-24 17:28:38
 */
export default {
	"teamSettings.title": "Team Settings",
	"teamSettings.tab1": "Team",
	"teamSettings.tab2": "Client",

	"teamSettings.team.rename.modal.title": "Rename the team",
	"teamSettings.team.rename.modal.label": "Team name",
	"teamSettings.team.rename.modal.ok": "Save",
	"teamSettings.team.rename.success": "Team name updated successfully",
	"teamSettings.team.invite.button": "Invite members",
	"teamSettings.team.invite.modal.title": "Invite members",
	"teamSettings.team.invite.modal.label": "Email",
	"teamSettings.team.invite.modal.placeholder": "Emails, space or comma separated",
	"teamSettings.team.invite.modal.ok": "Invite",
	"teamSettings.team.invite.success.message": "Invitation sent!",
	"teamSettings.team.invite.pending.text": "(Invitation Pending)",
	"teamSettings.team.table.title": "Team members",
	"teamSettings.team.table.action.remove": "Remove",
	"teamSettings.team.table.action.resent": "Resend invitation",
	"teamSettings.team.resent.modal.title": "Resend invitation",
	"teamSettings.team.resent.modal.text": "Are you sure you want to resend the invitation to {{email}}?",
	"teamSettings.team.remove.modal.title": "Delete {{email}}?",
	"teamSettings.team.remove.modal.text": "The {{email}} will be deleted immediately. This action can't be undone.",
	"teamSettings.team.remove.modal.ok": "Remove",

	"teamSettings.client.tip": "You can invite clients who can only view email reports and won‘t have access to your account.",
	"teamSettings.team.tip":
		"You can invite members who have full access to all AdSurgebot features and connected ad accounts. However, members will have limited access to the upgrade and billing settings.",
	"teamSettings.client.invite.button": "Invite Clients",
	"teamSettings.client.invite.modal.title": "Invite Clients",
	"teamSettings.client.invite.modal.email.label": "Email",
	"teamSettings.client.invite.modal.email.placeholder": "Client email",
	"teamSettings.client.invite.modal.name.label": "Name",
	"teamSettings.client.invite.modal.name.placeholder": "Full name or company",
	"teamSettings.client.invite.success.message": "Invitation sent!",
	"teamSettings.client.table.title": "Clients",
	"teamSettings.client.table.action.remove": "Remove"
};
